<script lang="ts" setup>
export interface WidgetPagesProps {
    data: {
        data: Page[]
        title: string
        subtitle: string
        tag: string
    }
}

const props = defineProps<WidgetPagesProps>()
const links = computed<VNuxtLinkTo[]>((): VNuxtLinkTo[] =>
    props.data.data.map((item) => {
        return {
            name: item.title,
        }
    })
)
</script>
<template>
  <section data-cy="widget_pages">
    <Tracker :data="{ position: props.data.title }">
      <BoxHeader
        heading-level="h2"
        :heading="props.data.title"
        :subtitle="props.data.subtitle"
      >
        <template #tag>
          <Tag
            class="text-uppercase"
            text-color="black-1"
            background-color="gray-1"
            size="small"
          >
            {{ props.data.tag }}
          </Tag>
        </template>
      </BoxHeader>
      <WidgetPagesTabs
        :links="links"
        :data="props.data.data"
        :select-label="$t('Vyberte službu')"
      />
    </Tracker>
  </section>
</template>
